import React, { FC } from 'react'
import { Modal, ModalProps } from '../../Modal'
import { TemplateSheetInfoModalContent } from './content'
import { useAppDispatch } from '../../../app/hooks'
import { handleDefaultTemplateSheetModal} from '../../../features/modals/modalsSlice'


export const TemplateSheeInfoModal: FC<ModalProps> = ({ opened, level }) => {
    const dispatch = useAppDispatch()

    const handleModal = () => {
        dispatch(handleDefaultTemplateSheetModal())
    }
    
    return (
        <Modal opened={opened}>
            <TemplateSheetInfoModalContent level={level} handleModal={handleModal} />
        </Modal>
    )
}
